import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from '../../shared/guard/authentication-guard';
import { ModuleRedirectGuard } from '../../shared/guard/module-redirect-guard';

const routes: Routes = [
  {
    path: 'Cms',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, ModuleRedirectGuard],
    data: { moduleRedirect: 'cms' },
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CmsRoutingModule {}
